module.exports = __webpack_public_path__ + "Flama-ThinItalic.woff2?1bbd046e3c24462c723620d0a5160a67";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-ThinItalic.woff2
// module id = 932
// module chunks = 0